<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="nmInterface && !slots.table"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :column-edit="columnEdit || paintCell"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
              @click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            >
              <template v-for="(v, slot) in scopedSlotsComputer" v-slot:[slot]="props">
                <slot :name="slot" v-bind="props" />
              </template>
            </jt-data-table>

            <slot
              v-if="nmInterface"
              name="table"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :selection="selection"
              :action-button="actionButton"
              :show-message="showMessage"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :multiselect="multiselect"
              :noneselect="noneselect"
              :click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import { campaignStatus } from 'src/shared/inf-tabela-descricao/CampaignStatus.enum.js'
import { formatSegmentationFilterDisplay, formatSegmentationFilterTitle, escapeHtml, parseSegmentationFilter } from '../utils/segmentationFilterUtils.js'
import { recurrenceType } from 'src/shared/inf-tabela-descricao/RecurrenceType.enum.js'

const { pageTable } = JtCrud

@Component({
  mixins: [pageTable],
  components: {
    JtDataTable
  },
  props: {
    name: String,
    page: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    parent: Object,
    rowButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    insideModal: {
      required: false,
      type: Boolean,
      default: false
    },
    cleanLayout: {
      required: false,
      type: Boolean,
      default: false
    },
    columnEdit: {
      type: Function
    },
    selectionForce: {
      required: false,
      type: Boolean,
      default: false
    },
    bottomEdit: {
      type: Function
    },
    rowSet: {
      type: Function
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    noneselect: {
      type: Boolean,
      default: false
    }
  }
})
class CampaignPageTable extends Vue {
  refresh () {
    this.$refs?.jtDataTable?.refresh()
  }

  updated () {
    this.refresh()
  }

  selection (data) {
    this.$emit('selection', data)
  }

  actionButton (data, params) {
    this.$emit('action-button', data, params)
  }

  showMessage (data) {
    this.$emit('show-message', data)
  }

  paintCell (_cell) {
    try {
      const colName = (_cell?.col?.name || '').toString()

      // Processar apenas a primeira coluna status
      if (colName.toLowerCase() === 'status') {
        // Se o valor for um código numérico, pintar
        if (!isNaN(Number(_cell.col.value))) {
          return this.paintStatusCell(_cell)
        }
      }
      // Formatar segmentationFilter: mostrar apenas labels com quebras de linha
      if (colName.toLowerCase() === 'segmentationfilter') {
        return this.paintSegmentationFilterCell(_cell)
      }
    } catch (e) {
      console.error('paintCell error', e)
    }
    return undefined
  }

  paintStatusCell (_cell) {
    const raw = _cell.col.value
    const code = Number(raw)

    const statuses = campaignStatus()

    let dotColor = 'rgb(112, 112, 112)' // default gray
    let label = String(raw || '')

    if (!Number.isNaN(code) && code !== 0) {
      if (code === statuses.ENDED.key) {
        dotColor = 'rgb(0, 98, 169)' // blue
        label = statuses.ENDED.label
      } else if (code === statuses.ACTIVE.key) {
        dotColor = 'rgb(0, 97, 59)' // green
        label = statuses.ACTIVE.label
      } else if (code === statuses.PAUSED.key) {
        dotColor = 'rgb(209, 142, 75)' // yellow
        label = statuses.PAUSED.label
      } else if (code === statuses.DRAFT.key) {
        dotColor = 'rgb(112, 112, 112)' // gray
        label = statuses.DRAFT.label
      }
    }

    const dotStyle = `background-color: ${dotColor}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; vertical-align: middle;`

    return `
      <div style="display: flex; align-items: center; gap: 8px;">
        <span style="${dotStyle}"></span>
        ${label}
      </div>
    `
  }

  paintSegmentationFilterCell (_cell) {
    try {
      const raw = _cell?.col?.value
      const display = formatSegmentationFilterDisplay(raw, { gettextFn: this.$gettext }) || '-'
      const title = formatSegmentationFilterTitle(raw) || ''
      return `<span title="${escapeHtml(title)}">${display}</span>`
    } catch (e) {
      return String(_cell?.col?.value || '')
    }
  }
}

export default CampaignPageTable
</script>
